import { getNodeAnimation } from "./get-node-animation.js";
import { hasEntranceAnimation } from "./has-entrance-animation.js";
const getAnimationDomAttrs = (node) => {
  const animation = getNodeAnimation(node);
  if (!animation || !node.id) {
    return {};
  }
  return {
    "data-ricos-animation": node.id,
    ...hasEntranceAnimation(animation) ? { "data-ricos-entrance": "" } : {}
  };
};
export {
  getAnimationDomAttrs
};
//# sourceMappingURL=get-animation-dom-attrs.js.map
